import React from "react";

const PageLayout = ({
  title,
  desc,
  avatar,
  breadcrumb = [],
  children,
  extra,
  headerContent,
}) => {
  return (
    <div>
      {/* Page Header */}
      {(title || headerContent || desc) && (
        <div
          
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <div>
              {title && (
                <h2 style={{ margin: 0, fontWeight: 600 }}>{title}</h2>
              )}
              {desc && (
                <p style={{ margin: "4px 0 0", color: "#888" }}>{desc}</p>
              )}
            </div>
            <div>{headerContent || extra}</div>
          </div>
        </div>
      )}

      {/* Page Content */}
      <div>
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
